import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Share from '../components/Share'
import SideOverlap from './sideOverlap'
import SchoolApplicationForm from '../components/ApplicationForm/School'


export default function SchoolApplication() {
    return (
        <>
            <Header />
            <SchoolApplicationForm />
            <Share />
            <Footer />
            <SideOverlap />
        </>
    )
}
